"use client"
import React, {useState, useEffect} from 'react'
import style from "./hamburgeroverlaymenu.module.scss";
import {GiHamburgerMenu} from "react-icons/gi";
import Image from 'next/image'
import {useTekstClient} from "hooks/useTekstClient";
import { useSWRConfig} from "swr"
import {useAxios} from "../../../hooks/useAxios";
import LocalizedLinkClient from "../../LocalizedLink/LocalizedLinkClient";

export default function HamburgerOverlayMenu({ isTop,isMkgEu, locale = "nl-NL" }) {

    const {get} = useAxios();
    const [showOverlayMenu, setShowOverlayMenu] = useState(false)
    const {tekst, isLoadingTekst} = useTekstClient()

    const {mutate} = useSWRConfig()
    const [vertalingData, setVertalingData] = useState()

    useEffect(() => {
        get('/released/languages')
            .then((res) => {
                const dataLang = []

                res.data.forEach((d) => {
                    const obj = {
                        id: d.id,
                        taal: d.naam,
                        img_path: `/media/lang-${d.naam.toLowerCase()}-icon.png`,
                        displayImage: true
                    }

                    dataLang.push(obj)
                })

                setVertalingData(dataLang)
            })
    }, []);

    function handleClose() {
        setShowOverlayMenu(false)
    }


    function getRegionFromLocale(locale) {
        if (typeof locale !== 'string') return null;

        const parts = locale.split('-');
        return parts.length === 2 ? parts[1].toUpperCase() : null;
    }


    return <div className={style.hamburgerMenuContainer}>
        {isMkgEu ? <div onClick={() => setShowOverlayMenu(true)} className={`${style.hamburger} ${!isTop ? style.hamburgerBlue : ''}`}>
            <GiHamburgerMenu/>
        </div> : <div onClick={() => setShowOverlayMenu(true)} className={`${style.menuItem} asLink`}>{tekst('algemeen:menu:Menu')}</div>}

            <div className={`${style.overlayMenu} ${showOverlayMenu ? style.overlayMenuShow : ''}`}>
                {showOverlayMenu && <div className={style.menuContainer}>


                    <div className={`${style.menuClose}`} onClick={handleClose}/>


                    <ul className={style.ulMainNav}>
                        <li>
                            <LocalizedLinkClient href={`/`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:home:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg3-erp-software`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg3erp:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg5-erp-systeem`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg5erp:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mkg5-erp-pakket`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:mkg5erpsysteem:linktekst')}
                            </LocalizedLinkClient>
                        </li>
                        <li>
                            <LocalizedLinkClient href={`/mkg-add-ons`} onClick={handleClose}>
                                {tekst('website:menu:addons')}
                            </LocalizedLinkClient>
                        </li>
                        <li>
                            <LocalizedLinkClient href={`/over-mkg`} onClick={handleClose}>
                                {tekst('mkgeu:menu:hamburger:overmkg:linktekst')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/over-mkg#vacatures`} onClick={handleClose}>
                                {tekst('website:menu:vacatures')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mijn-mkg/support`}
                                  onClick={handleClose}>
                                {tekst('website:menu:support')}
                            </LocalizedLinkClient>
                        </li>

                        <li>
                            <LocalizedLinkClient href={`/mijn-mkg/support`} onClick={handleClose}>
                                {tekst('website:menu:mijnmkg')}
                            </LocalizedLinkClient>
                        </li>

                    <li>
                        <div id="vc-lang" className={style.vertalingContainer}>
                            {vertalingData?.map(vertaling => {
                                return <span key={`vertaling_a_${vertaling.taal.toLowerCase()}`}
                                             onClick={function () {

                                                 const lang = vertaling.taal.toLowerCase();
                                                 const localeFull = `${lang}-${getRegionFromLocale(locale)}`;

                                                 get( `/locale/${vertaling.taal.toLowerCase()}`).then(response =>{
                                                     if(response.status === 200) {
                                                         mutate(key => true)
                                                         window.location.reload()
                                                     }
                                                 })
                                                 document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;

                                                 }}
                                                 className={`${style.itemLangShort}`}>
                                    { vertaling.displayImage && <Image
                                        src={vertaling.img_path}
                                        width={32}
                                        height={24}
                                        alt="Picture of a country flag"
                                        onError={() => {
                                            setVertalingData(prev =>
                                                prev?.map(v =>
                                                    v.id === vertaling.id ? { ...v, displayImage: false } : v
                                                )
                                            )
                                        }}
                                    />}
                                                <div>{vertaling.taal}</div>
                                            </span>
                                })}
                            </div>
                        </li>
                    </ul>
                <div className={style.menuBottom}>
                    <ul>
                        <li><LocalizedLinkClient disabled href={`/disclaimer`} onClick={handleClose}>
                            Disclaimer
                        </LocalizedLinkClient></li>
                        <li><LocalizedLinkClient disabled href={`/sitemap`} onClick={handleClose}>
                            Sitemap
                        </LocalizedLinkClient></li>
                        <li><LocalizedLinkClient disabled href={`/privacy`} onClick={handleClose}>
                            Privacy
                        </LocalizedLinkClient></li>
                    </ul>
                    <div>
                        {tekst('website:menu:submenu:ondertekst')}
                    </div>
                </div>
                </div>
                }
            </div>
        </div>
}
